export type RefreshSignal = {
  type: 'start' | 'success' | 'unauthorized' | 'failed'
  owner: string
  at: number
  sessionId?: string | null
}

export const parseRefreshSignal = (value: unknown): RefreshSignal | null => {
  if (!value || typeof value !== 'object') {
    return null
  }

  const record = value as Partial<RefreshSignal>
  if (
    (record.type !== 'start' &&
      record.type !== 'success' &&
      record.type !== 'unauthorized' &&
      record.type !== 'failed') ||
    typeof record.owner !== 'string' ||
    typeof record.at !== 'number' ||
    (record.sessionId !== undefined && record.sessionId !== null
      && typeof record.sessionId !== 'string')
  ) {
    return null
  }

  return record as RefreshSignal
}

export const buildUnauthorizedRefreshError = (): Error & {
  response?: { status: number }
} => {
  const error = new Error('Refresh unauthorized') as Error & {
    response?: { status: number }
    isAxiosError?: boolean
  }
  error.response = { status: 401 }
  error.isAxiosError = true
  return error
}
